<div id="alert-additional-content-4" class="container mx-auto p-4 mb-4 text-yellow-800 border border-yellow-300 rounded-lg bg-yellow-50 mt-10 sm:mt-20" role="alert" data-aos="fade-up" data-aos-duration="200" data-aos-delay="200">
    <div class="flex items-center">
        <!-- Icono de alerta -->
        <svg class="flex-shrink-0 w-4 h-4 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
        </svg>
        <span class="sr-only">Info</span>
        <h3 class="text-lg font-medium">¡Has iniciado sesión con una contraseña temporal!</h3>
    </div>
    <div class="mt-2 mb-4 text-sm">
        Te recomendamos que inicies sesión con tu contraseña personal. Si la olvidaste o es tu primer ingreso, cambia tu contraseña lo antes posible para asegurar la seguridad de tu cuenta.
        Por favor, visita el portal de <strong class="text-yellow-800 hover:text-yellow-900">miperfil.catastroantioquia-mas.com</strong> (ir a perfil usuario) para realizar el cambio de contraseña.
    </div>
</div>
